// extracted by mini-css-extract-plugin
export var acceptButton = "_24-5";
export var fullContent = "_24-4";
export var link = "_24-6";
export var linkIcon = "_24-7";
export var sideContent = "_24-3";
export var sideImage = "_24-2";
export var sideImageWrapper = "_24-1";
export var splitLayout = "_24-0";